import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { I18nProvider } from './i18n';
import './index.css';
import App from './App';
import { MobilePhotoUploadPage } from './pages/MobilePhotoUploadPage';
import reportWebVitals from './reportWebVitals';
import { analyticsService } from './services/analyticsService';

// Pairing credentials are consumed in memory before any analytics initialization.
const isPhotoUpload = window.location.pathname.replace(/\/$/, '') === '/photo-upload';
const pairingToken = isPhotoUpload ? window.location.hash.slice(1) : '';
if (isPhotoUpload) {
  window.history.replaceState(null, '', window.location.pathname);
  const referrer = document.createElement('meta');
  referrer.name = 'referrer'; referrer.content = 'no-referrer';
  document.head.appendChild(referrer);
} else {
  analyticsService.init();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <I18nProvider>
      <>{isPhotoUpload ? <MobilePhotoUploadPage pairingToken={pairingToken} /> : <App />}</>
    </I18nProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
